import { HttpStatusCode } from 'axios';

import { useHttp } from '@/composables';
import { useAuthStore, useCartStore } from '@/store';

export default async (to, from, next) => {
  const authStore = useAuthStore();
  const cartStore = useCartStore();

  if (!authStore.isLoaded) {
    authStore.loading = true;

    if (to.meta.requiresAuthentication || to.meta.requiresAdmin) {
      const profileResponse = await useHttp().get('/profile');

      /*
             * 1. Determine if the user is logged in. If they are, store their profile information on the auth authStore.
             * 2. If the user isn't logged in, make an API call to start a session for the user, allowing the items in their cart to be persisted.
             * */
      if (profileResponse.statusCode === HttpStatusCode.Ok) {
        authStore.user = profileResponse.data;
      }

      await cartStore.loadCart();

      authStore.isLoaded = true;
      authStore.loading = false;
    } else {
      const profilePromise = useHttp().get('/profile');

      profilePromise.then((response) => {
        /*
                 * 1. Determine if the user is logged in. If they are, store their profile information on the auth authStore.
                 * 2. If the user isn't logged in, make an API call to start a session for the user, allowing the items in their cart to be persisted.
                 */
        if (response.statusCode === HttpStatusCode.Ok) {
          authStore.user = response.data;
        }
      });

      const cartPromise = cartStore.loadCart();

      Promise.all([profilePromise, cartPromise]).then(() => {
        authStore.isLoaded = true;
        authStore.loading = false;
      });
    }
  }

  // If the user tries to access an authenticated page and they're not authenticated, then redirect them away from the page
  if (to.meta.requiresAuthentication && !authStore.isAuthenticated) {
    next({ name: 'app_event_list' });
  }
  // If a user who is not an admin tries to access an admin page, redirect them away from the admin page
  else if (to.meta.requiresAdmin && !authStore.user?.isAdmin) {
    next({ name: 'app_event_list' });
  } else {
    next();
  }
};
